module.exports = __webpack_public_path__ + "static/phone2.4ba6d742.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/phone2.svg
// module id = 238
// module chunks = 35783957827783 95715928098905 172322841747965